export default __webpack_public_path__ + "static/media/Group_17.9bed478a.png";